import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
import FEditLabelsDrawer from './FEditLabelsDrawer';

interface fEditLabelsDrawerProps {
  labels: string[];
  resourceTypeCode?: string;
}

type ReturnData = string[] | null;

function fEditLabelsDrawer({
  labels,
  resourceTypeCode,
}: fEditLabelsDrawerProps): Promise<ReturnData> {
  return new Promise<ReturnData>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(
      <FEditLabelsDrawer
        labels={labels}
        resourceTypeCode={resourceTypeCode}
        onConfirm={(labels) => {
          resolve(labels);
        }}
        onClose={() => {
          resolve(null);
          setTimeout(() => {
            root.unmount();
            div.remove();
          }, 300);
        }}
      />,
    );
  });
}

export default fEditLabelsDrawer;
